import { action } from "mobx";
import TourVideoRegenerationRepository from "~/repository/Tour/TourVideoRegenerationRepository";
import NestStore from "../NestStore";

class TourVideoRegenerationStore extends NestStore {
  tourVideoRegenerationRepository = null;

  constructor() {
    super();

    this.tourVideoRegenerationRepository = new TourVideoRegenerationRepository();
  }

  @action
  create(tourId) {
    return this.tourVideoRegenerationRepository.create(tourId).catch(error => {
      this.errorMessage = error.message;
      throw error;
    });
  }
}

export default TourVideoRegenerationStore;
